// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../../components";
import {
  redeem_voucher,
  getMerchantDeals,
  export_PurchaserList
} from "../../../redux/actions/voucherActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import loader from "../../../style/loader/loader.scss";
import Dialog from "react-bootstrap-dialog";
import ReactAutocomplete from "react-autocomplete";
import Workbook from "react-excel-workbook";
import MerchantPayout from "./MerchantPayout";
import auth from "../../../services/auth";
import { Link } from "react-router-dom";

let dataSet1 = [];
const history = createHashHistory();

let isLoading = "false",
  headers = [],
  data1 = [],
  userID = "";
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealID: "",
      deallist: [],
      dealIDs: [],
      show: false,
      alertMessage: "",
      voucherData: "",
      voucher: "",
      filename: "",
      exportdata: [],
      note: "",
      merchantinfo:"",
      merchantID: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";

    userID = this.props.match.params.user_id
      ? this.props.match.params.user_id
      : "";
    if (userID !== "") {
      this.props.getMerchantDeals(userID);
    } else {
      const userinfo = auth.getUserInfo();
      if (userinfo.user_id !== "") {
        this.props.getMerchantDeals(userinfo.user_id);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        // console.log(nextProps.merchantdealList.data.merchantInfo.legalName)
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data.data });
        let merchant=  nextProps.merchantdealList.merchantInfo? nextProps.merchantdealList.merchantInfo:{} ;
        
        this.setState({ merchantinfo:merchant.legalName, merchantID: merchant.merchant_id});
      }
    }

    if (this.props.exportList !== nextProps.exportList) {
      if (nextProps.exportList) {
        isLoading = "false";
        this.setState({ exportdata: nextProps.exportList.data });
      }
    }

    if (this.props.redeemvoucher !== nextProps.redeemvoucher) {
      if (nextProps.redeem_voucher) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.redeemvoucher.message);
        this.state.voucher = "";
        this.state.note = "";

        this.setState({ voucherData: nextProps.redeemvoucher.data });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      isLoading = "false";
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
        this.state.voucher = "";
        this.state.note = "";
      }
    }
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleListChangeOnDeal(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    let options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ dealIDs: value });
    this.setState({ disabled: false });
  }

  handleVoucher = () => {
    this.handleDismiss();
    if (!this.state.voucher) {
      this.setState({ voucherError: "red" });
    }else if(!this.state.note){
      this.setState({ noteError: "red" });
    } else {
      this.dialog.show({
        body: "Are you sure you want to redeem this voucher?",
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => {
            this.confirmRedeem();
          })
        ]
      });
    }
  };

  validate = () => {
    let isError = false;
    const errors = {};

    if (this.state.dealIDs.length === 0) {
      isError = true;
      this.setState({ dealIDsError: "red" });
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      const postData = {
        dealID: this.state.dealIDs,
        fileName: this.state.filename
      };
      this.props.export_PurchaserList(postData);
    }
  }

  confirmRedeem() {
    const postdata = {
      voucherNumber: this.state.voucher,
      note: this.state.note,
    };
    this.props.redeem_voucher(postdata);
    isLoading = "true";
    this.handleShow();
  }
  handleClose = () => {
    this.handleDismiss();
    this.state.voucherData = "";
  };

  render() {
    dataSet1 = this.state.exportdata;
    
    let dealListItems = [];
    let dealListData = this.state.deallist ? this.state.deallist : "";
    if (dealListData !== "") {
      dealListItems = dealListData.map((el, key) => (
        <option key={key} value={el.dealID}>
          {el.dealText}
        </option>
      ));
    }
    let voucher = this.state.voucherData ? this.state.voucherData : {};
    if (!this.state.voucherData) {
      isLoading = "false";
    }
    this.state.voucherData !== ""
      ? $("#voucherdiv *").prop("visible", true)
      : $("#voucherdiv *").prop("visible", false);

    headers = [
      { label: "Voucher Number", key: "voucherNumber" },
      { label: "Tracking Number", key: "trackingNumber" }
    ];

    data1 = this.state.exportdata;

    return (
      <AnimatedView>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="col-lg-12 add-sub-admin">
          <div className="panel">
          <header className="panel-heading">{this.state.merchantinfo}</header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormControl
                      className="halfWidth"
                      type="number"
                      value={this.state.voucher}
                      placeholder="Enter Voucher Number"
                      onChange={this.handleChange}
                      name="voucher"
                      style={{ borderColor: this.state.voucherError }}
                    />
                  </Col>
                  <Col md={6} xs={12}>
                    <FormControl
                      className="halfWidth"
                      type="text"
                      value={this.state.note}
                      placeholder="Enter Note"
                      onChange={this.handleChange}
                      name="note"
                      style={{ borderColor: this.state.noteError }}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="info"
                      type="submit"
                      onClick={this.handleVoucher.bind(this)}
                    >
                      Redeem{" "}
                    </Button>

                  </Col>
                </Row>
              </div>
            </div>
          </div>

          {this.state.voucherData ? (
            <div className="panel">
              <header className="panel-heading">Voucher Detail </header>
              <div className="col-lg-12 text-right">
                <Button bsStyle="info" onClick={this.handleClose.bind(this)}>
                  X
                </Button>
              </div>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasic1">
                        <ControlLabel>Voucher Number :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic2">
                        <ControlLabel>Voucher Type :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic3">
                        <ControlLabel>Quantity :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic4">
                        <ControlLabel>Voucher Value :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic5">
                        <ControlLabel>Offer :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic6">
                        <ControlLabel>Status :</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic7">
                        <ControlLabel>Expiry Date :</ControlLabel>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formBasic8">
                        <ControlLabel>{voucher.voucherNumber} </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic9">
                        <ControlLabel>{voucher.voucherType}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic10">
                        <ControlLabel>{voucher.quantity}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic11">
                        <ControlLabel> {voucher.voucherValue} </ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic12">
                        <ControlLabel>{voucher.dealText}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic13">
                        <ControlLabel> {voucher.status}</ControlLabel>
                      </FormGroup>
                      <FormGroup controlId="formBasic14">
                        <ControlLabel>{voucher.expiryDate}</ControlLabel>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {userID !== "" && this.state.deallist.length !== 0 ? (
            <div className="panel">
              <div className="panel-body">
                <div className="col-md-12">
                  <Row>
                    <Col>
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() => history.push(`/contract/view/${userID}`)}
                      >
                        View Contract
                      </Button>
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() =>
                          history.push(`/merchant/voucher/list/${userID}`)
                        }
                      >
                        Voucher List & Print
                      </Button>
                      <Button
                        bsSize="small"
                        bsStyle="success"
                        onClick={() =>
                          history.push(`/trackingnumbers/List/${userID}`)
                        }
                      >
                        Upload Tracking Numbers
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <form onSubmit={this.handleSubmit}>
            <div className="panel">
              <header className="panel-heading">
                Emails for Deal-buyers Report{" "}
              </header>
              <div className="panel-body">
                <div className="col-md-12">
                  <Row>
                    <Col md={12} xs={12}>
                      <FormGroup controlId="formdeallist">
                        <ControlLabel>
                          {" "}
                          Use this to pull purchaser email lists for specific
                          offers. Separate multiple offers by commas.{" "}
                        </ControlLabel>
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formdeallist">
                        <ControlLabel> DealIDs </ControlLabel>
                        <FormControl
                          name="dealIDs"
                          componentClass="select"
                          style={{ borderColor: this.state.dealIDsError }}
                          onChange={this.handleListChangeOnDeal.bind(this)}
                          value={this.state.dealIDs}
                          multiple
                        >

                          {dealListItems}
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="formfilename">
                        <ControlLabel>File name</ControlLabel>

                        <FormControl
                          className="halfWidth"
                          type="text"
                          value={this.state.filename}
                          placeholder="file name"
                          onChange={this.handleChange}
                          name="filename"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="BtnRow">
                    <Col md={12} xs={12}>
                      <Button bsStyle="info" type="submit" id="saveButton">
                        {" "}
                        Submit{" "}
                      </Button>
                      {this.state.exportdata.length !== 0 &&
                      this.state.dealIDs.length !== 0 &&
                      this.state.filename !== "" ? (
                        <Workbook
                          filename={this.state.filename + ".csv"}
                          element={
                            <button className="btn btn-primary">Export</button>
                          }
                        >
                          <Workbook.Sheet
                            data={this.state.exportdata}
                            name="Sheet A"
                          >
                            <Workbook.Column label="Offer ID" value="OfferID" />
                            <Workbook.Column
                              label="Voucher Number"
                              value="VoucherNumber"
                            />
                            <Workbook.Column
                              label="First Name"
                              value="FirstName"
                            />
                            <Workbook.Column
                              label="Last Name"
                              value="LastName"
                            />
                            <Workbook.Column label="Email" value="Email" />
                            <Workbook.Column label="Phone" value="Phone" />
                            <Workbook.Column
                              label="Voucher Status"
                              value="Status"
                            />
                            <Workbook.Column
                              label="Order Date"
                              value="OrderDate"
                            />
                          </Workbook.Sheet>
                        </Workbook>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </form>
          {this.state.merchantID &&
          <MerchantPayout key={this.state.merchantID} merchantID={(this.state.merchantID) ? this.state.merchantID : ""} />
          }
        </div>
      </AnimatedView>
    );
  }
}

const mapStateToProps = state => ({
  merchantdealList: state.voucherReducer.merchantdealList,
  redeemvoucher: state.voucherReducer.redeemvoucher,
  error: state.voucherReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  exportList: state.voucherReducer.exportList
});

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    redeem_voucher,
    renderAlert,
    clearAlert,
    getMerchantDeals,
    export_PurchaserList
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/merchant/dashboard/Dashboard.js